const BONUS_VARIANT_ID = 53589860974972;
// const BONUS_VARIANT_ID = null;

/**
 * Updates a cart item and manages the bonus product based on subscription status.
 * @param {number} line - The line item index (1-based).
 * @param {number} quantity - The new quantity.
 * @param {number|null} sellingPlan - The selling plan ID or null for one-time purchase.
 * @param {boolean} shouldReload - Whether to reload the page after completion.
 */
let isUpdating = false;

/**
 * Updates a cart item and manages the bonus product based on subscription status.
 * @param {number} line - The line item index (1-based).
 * @param {number} quantity - The new quantity.
 * @param {number|null} sellingPlan - The selling plan ID or null for one-time purchase.
 * @param {boolean} shouldReload - Whether to reload the page after completion.
 */
async function updateCartItem(
  line,
  quantity,
  sellingPlan,
  shouldReload = true,
) {
  if (isUpdating) {
    // console.log("Update already in progress, skipping...");
    return;
  }

  isUpdating = true;
  try {
    // console.log(
    //   `Updating line ${line} with quantity ${quantity} and selling plan ${sellingPlan}`,
    // );

    // 1. Update the main item
    const changeResponse = await axios.post("/cart/change.js", {
      line: line,
      quantity: quantity,
      selling_plan: sellingPlan,
    });

    const cart = changeResponse.data;
    await manageBonusProduct(cart);

    // 2. Optional reload
    if (shouldReload) {
      window.location.reload();
    }
  } catch (error) {
    console.error("Error updating cart item:", error);
    if (shouldReload) {
      window.location.reload();
    }
  } finally {
    isUpdating = false;
  }
}

async function handleItemRemove(line, id) {
  if (isUpdating) {
    console.log("Update already in progress, skipping...");
    return;
  }

  isUpdating = true;
  try {
    // 1. Remove the item
    const changeResponse = await axios.post("/cart/change.js", {
      line: line,
      quantity: 0,
    });

    const cart = changeResponse.data;
    if (BONUS_VARIANT_ID === null) return;

    if (id !== BONUS_VARIANT_ID) {
      await manageBonusProduct(cart);
    }

    if (id === BONUS_VARIANT_ID) {
      // 1. Tell the browser not to re-add it this session
      localStorage.setItem("bonusManuallyRemoved", "true");

      // 2. Tell Shopify it was manually removed (for the Order Tag)
      await axios.post("/cart/update.js", {
        attributes: {
          "Bonus Manually Removed": "true",
          "Bonus Removal Date": new Date().toLocaleString(),
        },
      });
    }

    // 2. Reload
    window.location.reload();
  } catch (error) {
    // console.error("Error removing item:", error);
    window.location.reload();
  } finally {
    isUpdating = false;
  }
}

/**
 * Checks the cart for subscriptions and adds/removes the bonus product accordingly.
 * @param {Object} cart - The current cart object.
 */
async function manageBonusProduct(cart) {
  const bonusInCart = cart.items.find(
    (item) => item.variant_id === BONUS_VARIANT_ID,
  );
  const hasAnySubscription = cart.items.some(
    (item) => item.selling_plan_allocation,
  );

  if (hasAnySubscription && !bonusInCart) {
    // console.log("Subscription found, adding bonus product...");
    try {
      await axios.post("/cart/add.js", {
        id: BONUS_VARIANT_ID,
        quantity: 1,
      });
    } catch (error) {
      console.error("Error adding bonus product:", error);
    }
  } else if (!hasAnySubscription && bonusInCart) {
    // console.log("No subscriptions found, removing bonus product...");
    try {
      // Note: we fetch the cart again to get fresh indices if multiple things changed
      const freshCartRes = await axios.get("/cart.js");
      const freshCart = freshCartRes.data;
      const bonusLineIndex =
        freshCart.items.findIndex(
          (item) => item.variant_id === BONUS_VARIANT_ID,
        ) + 1;

      if (bonusLineIndex > 0) {
        await axios.post("/cart/change.js", {
          line: bonusLineIndex,
          quantity: 0,
        });
      }
      // localStorage.setItem("bonusAdded", "false");
    } catch (error) {
      console.error("Error removing bonus product:", error);
    }
  } else {
    console.log("Bonus product state is already correct.");
  }
}

// Export functions to window
window.updateCartItem = updateCartItem;
window.manageBonusProduct = manageBonusProduct;
